import { z } from 'zod';
import { listSearchSchema } from '@/shared/patterns/list-search';
import { dynamicRulesFilters } from './dynamic-rules.filters';

export const dynamicRulesSearch = listSearchSchema({
  sheet: z.string().optional().catch(undefined),
  ...dynamicRulesFilters.shape,
});

/** `?duplicar=` salva como nova (DynamicRuleFormContainer.tsx:37); a gaveta do valor composto na URL. */
export const dynamicRuleDetailSearch = z.object({
  duplicar: z.coerce.string().optional().catch(undefined),
  sheet: z.string().optional().catch(undefined),
  condicao: z.string().optional().catch(undefined),
});
